import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective {

  @Output() clickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  public onClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    // Panels appended to body are physically outside but logically inside
    const clickedPrimeOverlay = !!targetElement.closest('.p-dropdown-panel, .p-overlaypanel, .p-multiselect-panel');
    if (!clickedInside && !clickedPrimeOverlay) {
      this.clickOutside.emit();
    }
  }
}
